import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import AccessCodeMapper from '../mappers/AccessCodeMapper';
import { IAccessCode } from '../../../pages/AccessCode/interfaces';

class AccessCodeService {
    private baseURL: string = `${urlHttpGov}/panel/access-code`;

    async listAccessCode(signal: AbortSignal): Promise<IAccessCode[]> {

        const { data } = await privateHttpClient.get(`${this.baseURL}`, { signal });

        return data.map((contact: any) => AccessCodeMapper.toDomain(contact));
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AccessCodeService();
